import { getFromLocalStorage, saveToLocalStorage } from "@/utils/localstorage";
export default {
  namespaced: true,
  state: {
    currentCurrency: getFromLocalStorage("currency", {
      country_code: "UK",
      currency: "GBP",
    }),
    currencies: [
      {
        country_code: "UK",
        currency: "GBP",
      },
      {
        country_code: "US",
        currency: "USD",
      },
    ],
  },
  getters: {
    getCurrentCurrency: (state) => state.currentCurrency,
    getAllCurrencies: (state) => state.currencies,
    getCurrencyByCode: (state) => (code) =>
      state.currencies.find((currency) => currency.country_code === code),
  },
  mutations: {
    setCurrentCurrency(state, currency) {
      state.currentCurrency = currency;
      saveToLocalStorage("currency", currency);
    },
  },
  actions: {
    setCurrentCurrencyByCode({ commit, rootGetters }, code) {
      commit(
        "setCurrentCurrency",
        rootGetters["currency/getCurrencyByCode"](code)
      );
    },
  },
};
